import React from 'react';
import { Box, Paper, Stack, Typography, Button, useTheme, alpha } from '@mui/material';
import { EventAvailable, ArrowForward } from '@mui/icons-material';

interface SessionsEmptyStateProps {
  onCreate: () => void;
}

const SessionsEmptyState: React.FC<SessionsEmptyStateProps> = ({ onCreate }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 4, sm: 6 },
        borderRadius: 3,
        border: `1px dashed ${alpha(theme.palette.primary.main, 0.3)}`,
        bgcolor: alpha(theme.palette.primary.main, 0.02),
        textAlign: 'center'
      }}
    >
      <Stack alignItems="center" spacing={2}>
        <Box
          sx={{
            width: 64, height: 64, borderRadius: '50%',
            bgcolor: alpha(theme.palette.primary.main, 0.10),
            color: theme.palette.primary.main,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
          <EventAvailable sx={{ fontSize: 32 }} />
        </Box>
        <Box>
          <Typography variant="h5" fontWeight={700} sx={{ mb: 1 }}>
            Set up your first academic session
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 480, mx: 'auto' }}>
            Sessions are the spine of your school year. Once you create and activate one,
            you can enrol students, build the curriculum, and run promotions when the year ends.
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          disableElevation
          endIcon={<ArrowForward />}
          onClick={onCreate}
          sx={{ mt: 1.5 }}
        >
          Create first session
        </Button>
      </Stack>
    </Paper>
  );
};

export default SessionsEmptyState;
